// extracted by mini-css-extract-plugin
module.exports = {"title":"TextSent_title__IR8RE","lottie":"TextSent_lottie__C5NC9"};